export default __webpack_public_path__ + "static/media/team1.2a135c57.png";